var React = require('react');

function IconLocation (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"패스_753","d":"M13.5 2A8.444 8.444 0 0 0 5 10.4C5 16.7 13.5 26 13.5 26S22 16.7 22 10.4A8.444 8.444 0 0 0 13.5 2zm-6.071 8.4a6.072 6.072 0 0 1 12.143 0c0 3.456-3.5 8.628-6.071 11.856-2.527-3.204-6.072-8.436-6.072-11.856z","className":"cls-1","transform":"translate(-5 -2)","key":0}),React.createElement("ellipse",{"id":"타원_111","cx":"3.036","cy":"3","className":"cls-1","rx":"3.036","ry":"3","transform":"translate(5.464 5.4)","key":1})]);
}

IconLocation.defaultProps = {"id":"icon_location","width":"17","height":"24","viewBox":"0 0 17 24"};

module.exports = IconLocation;

IconLocation.default = IconLocation;
